import { useCallback } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

export const useClearLocationState = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const clearState = useCallback(() => {
    navigate(location.pathname, { replace: true, state: {} });
  }, [navigate, location.pathname]);

  return { clearState };
};
